import React, { Suspense, useEffect, useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import Confetti from "./Confetti";
import MotionFromLeft from "./MotionFromLeft";
import MotionFromRight from "./MotionFromRight";
import { OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import Cube from "./Cube";
import "./card.css";

export const Contact = () => {
  const form = useRef();
  const [success, setSuccess] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    document.getElementById("card").onmousemove = (e) => {
      for (const card of document.getElementsByClassName("card")) {
        const rect = card.getBoundingClientRect(),
          x = e.clientX - rect.left,
          y = e.clientY - rect.top;

        card.style.setProperty("--mouse-x", `${x}px`);
        card.style.setProperty("--mouse-y", `${y}px`);
      }
    };
  }, []);

  const sendEmail = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs
      .sendForm(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_ID,
        form.current,
        process.env.REACT_APP_PUBLIC_KEY
      )
      .then(
        (result) => {
          console.log(result.text);
          setSending(false);
          setSuccess(true);
          form.current.value = "";
          e.target.reset();
        },
        (error) => {
          console.log(error.text);
          setSending(false);
          setSuccess(false);
        }
      );
  };

  return (
    <>
      <div
        id="contact"
        className="min-h-[600px] flex md:flex-row flex-col-reverse overflow-hidden"
      >
        <form
          id="card"
          ref={form}
          className=" card flex z-0 flex-col justify-center pl-0 sm:py-0 py-10 m-2 sm:m-20 rounded-xl border-[0.1px] border-[#64ffda] sm:w-[50%] items-center backdrop-blur-sm overflow-hidden  "
          onSubmit={sendEmail}
        >
          <label className="text-[#64ffda] mb-6 text-xl">Contact Me!</label>
          <MotionFromLeft>
            <input
              type="text"
              className="p-1 z-10 relative outline-none m-3 w-full text-white bg-transparent border-b-2 border-[#64ffda]"
              name="name"
              placeholder="Your Name..."
              required
            />
          </MotionFromLeft>
          <MotionFromRight>
            <input
              type="email"
              className="p-1 z-10 relative outline-none m-3 w-full text-white  bg-transparent border-b-2 border-[#64ffda]"
              name="email"
              placeholder="Your Email..."
              required
            />
          </MotionFromRight>
          <MotionFromLeft>
            <textarea
              name="message"
              className="p-3 z-10 relative m-3 rounded-lg w-full min-h-[150px] text-white border-2 backdrop-blur-xl bg-transparent border-[#64ffda]"
              placeholder="Your Message..."
              required
            />
          </MotionFromLeft>
          <button
            type="submit"
            className="text-[#64ffda] z-10 relative text-xl bg-[#64ffda border-2 border-[#64ffda] px-6 py-1 rounded-lg"
          >
            {sending ? "Sending..." : "Send"}
          </button>
        </form>
        {success ? <Confetti /> : null}
        <div className="sm:w-[50%] md:h-[600px] h-[300px] flex ">
          <Canvas camera={{ position: [5, 5, 5], fov: 20 }}>
            <Suspense fallback={null}>
              <ambientLight intensity={0.5} />
              <directionalLight position={[3, 2, 1]} />
              <Cube />
              <OrbitControls enableZoom={false} autoRotate />
            </Suspense>
          </Canvas>
        </div>
      </div>
    </>
  );
};

export default Contact;
